import {
  GET_PLC_SAFETY_DASHBOARD_STATS,
  GET_PLC_SAFETY_DASHBOARD_STATS_SUCCESS,
  GET_PLC_SAFETY_DASHBOARD_STATS_ERROR,
} from './actionTypes';

const initialState = {
  errorGetPlcSafetyDashboardStats: '',
  loadingGetPlcSafetyDashboardStats: false,
  stats: null,
};

const getPlcSafetyDashboardStats = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_SAFETY_DASHBOARD_STATS:
      state = { ...state, loadingGetPlcSafetyDashboardStats: true };
      break;
    case GET_PLC_SAFETY_DASHBOARD_STATS_SUCCESS:
      state = { ...state, loadingGetPlcSafetyDashboardStats: false, stats: action.payload.stats };
      break;
    case GET_PLC_SAFETY_DASHBOARD_STATS_ERROR:
      state = { ...state, errorGetPlcSafetyDashboardStats: action.payload, loadingGetPlcSafetyDashboardStats: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getPlcSafetyDashboardStats;
